<template>
  <div>
    <ScriptExecModal ref="ScriptExecModal"></ScriptExecModal>
    <Card>
      <Row class="sm-pc-w100">
        <Col :md="22">
          <Form :model="searchForm" ref="searchForm" inline :label-width="60">
            <FormItem label="脚本名称">
              <Input v-model="searchForm.name" style="min-width: 200px" />
            </FormItem>
            <FormItem label="脚本描述">
              <Input v-model="searchForm.desc" style="min-width: 200px" />
            </FormItem>
            <FormItem label="脚本类型">
              <Select v-model="searchForm.type" style="min-width:200px" clearable placeholder="">
                <Option v-for="item in allTypeData" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getTableData()">搜索</Button>
              <Button style="margin-left: 8px" @click="searchReset">重置</Button>
            </FormItem>
          </Form>
        </Col>
        <Col span="24" :md="2" class="align-right">
          <Button
            style="float: right;"
            @click="editScript(0)"
            type="primary"
            :style="{marginBottom: '10px'}"
            v-show="isScriptAdd"
            icon="md-add">添加脚本</Button>
        </Col>
      </Row>
      <Table
        border
        :loading="TableLoading"
        :data="script.data"
        :columns="script.columns">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: right;">
          <page
            :total="script.count"
            :current="script.page"
            :page-size="script.size"
            @on-change="getTableData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getOpsCenterScript, deleteOpsCenterScript } from '@/api/opscenter'
import ScriptExecModal from './script-exec-modal'
import { codemirror } from 'vue-codemirror-lite'
import 'codemirror/theme/mdn-like.css'
import 'codemirror/mode/python/python.js'
import 'codemirror/mode/shell/shell.js'
import 'codemirror/mode/go/go.js'

export default {
  name: 'script-manage',
  components: {
    'codemirror': codemirror,
    ScriptExecModal
  },
  data () {
    return {
      isScriptAdd: false,
      isScriptEdit: false,
      isScriptDelete: false,
      isScriptView: false,
      TableLoading: false,
      script: {
        data: [],
        columns: [
          {
            title: '脚本ID',
            key: 'id',
            tooltip: true,
            align: 'center',
            minWidth: 80
          },
          {
            title: '脚本名称',
            key: 'name',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '脚本描述',
            key: 'desc',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '脚本分类',
            key: 'type',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '添加人',
            tooltip: true,
            align: 'center',
            key: 'user_full_name',
            minWidth: 80
          },
          {
            title: '添加时间',
            tooltip: true,
            align: 'center',
            key: 'datetime_format',
            minWidth: 150
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 220,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: 'script_detail',
                        params: { 'id': params.row.id }
                      })
                    }
                  }
                }, '详情'),
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.scriptExecOpen(params.row)
                    }
                  }
                }, '启动'),
                h('Button', {
                  style: {
                    display: this.isScriptEdit ? 'inline-block' : 'none',
                    marginRight: '5px'
                  },
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editScript(params.row.id)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.Delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    style: {
                      display: this.isScriptDelete ? 'inline-block' : 'none'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 1,
        page: 1,
        size: 10
      },
      searchForm: {
        name: '',
        desc: '',
        type: ''
      },
      allTypeData: [
        { 'value': 'shell', 'label': 'shell' },
        { 'value': 'python', 'label': 'python' },
        { 'value': 'linuxyml', 'label': 'linux-yml' },
        { 'value': 'winyml', 'label': 'win-yml' },
        { 'value': 'winps1', 'label': 'powershell' }
      ]
    }
  },
  mounted: function () {
    this.initOperatePerm()
    this.getTableData()
  },
  methods: {
    // 初始化页面按钮权限（增删改查操作权限）
    initOperatePerm () {
      let permissions = this.$store.state.user.permissions
      if (permissions.indexOf('add_script') > -1) {
        this.isScriptAdd = true
      } else {
        this.isScriptAdd = false
      }
      if (permissions.indexOf('change_script') > -1) {
        this.isScriptEdit = true
      } else {
        this.isScriptEdit = false
      }
      if (permissions.indexOf('delete_script') > -1) {
        this.isScriptDelete = true
      } else {
        this.isScriptDelete = false
      }
      if (permissions.indexOf('view_script') > -1) {
        this.isScriptView = true
      } else {
        this.isScriptView = false
      }
    },
    // 打开编辑脚本
    editScript (id) {
      if (id) {
        this.$router.push({
          name: 'script_edit',
          params: { id: id }
        })
      } else {
        this.$router.push({
          name: 'script_add'
        })
      }
    },
    // 获取脚本列表数据
    getTableData (value = 1) {
      this.script.page = value
      let params = {
        size: this.script.size,
        page: this.script.page,
        name: this.searchForm.name,
        desc: this.searchForm.desc,
        type: this.searchForm.type
      }
      this.TableLoading = true
      getOpsCenterScript(params).then(res => {
        this.TableLoading = false
        this.script.data = res.data.results
        this.script.count = res.data.count
      }).catch(res => {
        this.TableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取脚本列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取脚本列表失败！服务器无响应'
          })
        }
      })
    },
    // 删除
    Delete (row) {
      deleteOpsCenterScript(row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 打开执行Modal
    scriptExecOpen (row) {
      this.$refs.ScriptExecModal.openModal(row)
    },
    // 初始化搜索表单
    searchReset () {
      this.searchForm = {
        name: '',
        desc: '',
        type: ''
      }
    }
  }
}
</script>

<style>
  @import '../../plugin/ztree/css/metroStyle/metroStyle.css';
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
